import { CaretDown } from "@phosphor-icons/react";

/* Нативный <details>: открытие с клавиатуры и состояние aria даёт браузер.
   Те же вопросы уходят в разметку FAQPage (AEO, A7 скилла). */
export const ITEMS = [
  {
    q: "Сколько это стоит?",
    a: "Зависит от задачи, поэтому цену называю в разборе, а не на странице. Небольшая доработка и большой слой на базе ИИ стоят разных денег, и называть цифру вслепую значит гадать. Сначала смотрю процесс, потом называю цену. Точную смету считаем по проекту.",
  },
  {
    q: "Сколько времени это займёт?",
    a: "Небольшие задачи, например лендинг, простой бот, один агент на ИИ или автоматизация, занимают от 3 дней до 3 недель. Проекты побольше, вроде системы из нескольких агентов на ИИ, бота с платежами или приложения в Telegram, занимают от 3 до 8 недель. Точный срок называю после разбора, с запасом.",
  },
  {
    q: "А если не сработает?",
    a: "Метрику согласуем до старта. Если не сработало, скажу прямо. Поэтому начинаю с узкого MVP, а не с платформы: цена ошибки должна быть маленькой.",
  },
  {
    q: "Нужен ли ИИ моему бизнесу вообще?",
    a: "Не всегда. Я не внедряю ИИ вслепую: в карте процесса есть вопрос, нужен ли он здесь и куда. Если хватит обычной автоматизации, так и напишу.",
  },
  {
    q: "Я уже работал с подрядчиками, и вышло не то. Что будет иначе?",
    a: "Проект ведёт один человек, тот, кто его пишет, без менеджера между нами. Метрику согласуем до старта, начинаем с узкого MVP, чтобы ошибка стоила недорого. Если не работает, скажу прямо и не буду тянуть деньги.",
  },
  {
    q: "Что будет с моими данными?",
    a: "Если данные чувствительные, использую российскую инфраструктуру и модели на отдельном сервере, ничего не отправляю наружу. Это дороже и дольше, поэтому скажу об этом заранее, а не в конце.",
  },
  {
    q: "Почему разбор письменный, а не созвон?",
    a: "На созвоне продают, а в тексте думают. Хочешь созвон, он будет после разбора.",
  },
  {
    q: "С чего начать?",
    a: "С разбора. Описываешь процесс в форме своими словами, и в течение 2 рабочих дней я присылаю разбор: что за процесс, где утекают часы и деньги, что можно закрыть и что для этого нужно, плюс вилку цены. Бесплатно и без обязательств. Если задача не под меня, напишу об этом и объясню почему.",
  },
];

const schema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: ITEMS.map(({ q, a }) => ({
    "@type": "Question",
    name: q,
    acceptedAnswer: { "@type": "Answer", text: a },
  })),
};

export const Faq = () => (
  <div className="flex flex-col gap-2" data-testid="faq-list">
    <script type="application/ld+json">{JSON.stringify(schema)}</script>
    {ITEMS.map((it, i) => (
      <details key={i} className="surface group">
        <summary
          data-testid={`faq-question-${i}`}
          className="flex cursor-pointer items-center justify-between gap-6 p-6 text-lg transition-colors duration-300 ease-smooth hover:bg-ink-2/40"
        >
          {it.q}
          <CaretDown size={20} className="chev shrink-0 text-muted transition-transform duration-500 ease-smooth" />
        </summary>
        <p className="max-w-[680px] px-6 pb-6 text-base text-muted" data-testid={`faq-answer-${i}`}>
          {it.a}
        </p>
      </details>
    ))}
  </div>
);
